import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isEmail } from 'class-validator';

/**
 * Validator for email fields. Uses the same `isEmail` check that the backend DTOs apply through the
 * `@IsEmail()` decorator, so a value accepted by the form is also accepted by the API.
 * Empty values are considered valid, combine with `Validators.required` for mandatory fields.
 */
export const isEmailValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    if (control.value === null || control.value === '') {
        return null;
    }

    return isEmail(control.value) ? null : { email: true };
};

/**
 * Validator for rich-text (HTML) fields.
 * Strips all HTML tags and checks that the remaining text is non-empty.
 * Handles cases where editors emit empty markup like `<div><br></div>`.
 */
export function nonEmptyHtml(control: AbstractControl): ValidationErrors | null {
    const text = (control.value ?? '').replace(/<[^>]*>/g, '').trim();
    return text.length > 0 ? null : { required: true };
}
